<script>
    /**
 *
 *
 *
 *
 *
 */

    import { generateRandomId } from "../utils/IdentifierGenerator.js";
    import { getContext } from "svelte";
    import { key as contentDresonRuleCtxKey } from "../context/contentDresonRule.js";

    /*                */
    let { deal = null, variationId = null, personalisedUser = false } = $props();

    const sheetId = generateRandomId(16);
    const dresonRule = getContext(contentDresonRuleCtxKey);
    const contextDresonParam = dresonRule ? `&contextDreson=${dresonRule}` : "";
</script>

{#if deal && deal.imageUrl}
    <button
        onclick={(event) => {
            event.preventDefault();
            event.stopPropagation();
        }}
        data-oc-sheet-v1-create
        data-oc-sheet-v1-create.id="reco_deal_sheet_{sheetId}"
        data-oc-sheet-v1-create.base64Url={btoa(
            `/benefit-sheet/sheet/recoProductCampaignFlag/${deal.id}?variationId=${variationId}${contextDresonParam}&personalized=${personalisedUser}`
        )}
        data-oc-sheet-v1-create.url={`/benefit-sheet/sheet/recoProductCampaignFlag/${deal.id}?variationId=${variationId}${contextDresonParam}&personalized=${personalisedUser}`}
        aria-label="Deal badge"
        class="reco_cinema__image__badge reco_cinema__image__deal_badge"
        style={`background: url(${deal.imageUrl}) center center/50px 50px no-repeat;`}
    >
    </button>
{/if}

<style>
    .reco_cinema__image__badge {
        background-size: cover;
    }

    .reco_cinema__image__deal_badge {
        position: absolute;
        width: 50px;
        height: 50px;
        z-index: 1;
        top: 12px;
        left: 12px;
        border: none;
        cursor: pointer;
    }
</style>
